import { useEffect, useRef } from 'react';
import { useInView, IntersectionOptions } from 'react-intersection-observer';
import useGlobalNavHeader from './globalnavheader/provider';

interface Options {
  scrollHeight?: number;
  targetRef?: any;
  cb?: (sticky?: boolean, entry?: any) => void;
  intersectionOptions?: IntersectionOptions;
  skipSubSectionStickyForRoute?: boolean;
}

const HAVE_WE_FIXED_STREAMLINED_NAVHEADER_STICKY = false;

/**
 * 页面滚动时候添加吸顶下部分阴影
 * @param ref 需要添加阴影的元素
 * @param options
 */
const useSticky = (options?: Options) => {
  const globalNavHeader = useGlobalNavHeader();
  const streamlinedHeader = globalNavHeader?.streamlinedHeader || false;
  const __defaultSkipSubSectionStickyForRoute = !streamlinedHeader
    ? false
    : !HAVE_WE_FIXED_STREAMLINED_NAVHEADER_STICKY;

  const { scrollHeight = 47, intersectionOptions, skipSubSectionStickyForRoute } = options;

  const __shouldSkipStickyFeature =
    skipSubSectionStickyForRoute !== undefined ? skipSubSectionStickyForRoute : __defaultSkipSubSectionStickyForRoute;

  const { ref, inView, entry } = useInView({
    threshold: 0,
    rootMargin: `${0 - scrollHeight}px 0px 0px 0px`,
    initialInView: true,
    ...intersectionOptions
  });

  useEffect(() => {
    if (__shouldSkipStickyFeature === true) return;

    let targetRef = options?.targetRef;
    if (options.cb) {
      options.cb(!inView, entry);
      return;
    }
    if (!targetRef?.current) return;
    targetRef.current.style.boxShadow = inView ? '' : '0px 3px 8px rgba(0, 0, 0, 0.09)';
  }, [inView, scrollHeight]);

  return {
    eleRef: ref,
    entry
  };
};

export default useSticky;
